module.exports = __webpack_public_path__ + "static/media/colicoli03.6f7d5400.webp";